import React from 'react'
import LeftBar from '../Components/LeftBar'
import Dashnav from '../Components/Dashnav'
import OtherStudentsComp from './OtherStudentsComp'

function OtherStudents() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <OtherStudentsComp/>      
        </div>
    </div>
  )
}

export default OtherStudents